module.exports = __webpack_public_path__ + "static/media/icon-bing.dd69b3cf.svg";